/**
 * Download a file from blob content
 * @param content - The content of the file
 * @param filename - The name of the file to download
 * @param mimeType - The MIME type of the file (default: 'application/octet-stream')
 */
export function downloadFile(
  content: string | Blob,
  filename: string,
  mimeType = 'application/octet-stream',
): void {
  const blob =
    content instanceof Blob ? content : new Blob([content], { type: mimeType })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

/**
 * Download JSON data as a file
 * @param data - The data to stringify and download
 * @param filename - The name of the file to download
 */
export function downloadJson<T = unknown>(data: T, filename: string): void {
  const jsonString = JSON.stringify(data, null, 2)
  downloadFile(jsonString, filename, 'application/json')
}
